import * as types from "../../actions/types";



const initialState = null


export default function exportReducer (state = initialState, action) {
  switch (action.type) {
      
    case types.SET_SETTINGS_EXPORT_DATA:
      return action.payload

    default:
      return state;
  }
}